import React from "react";
import { makeStyles, Paper, Typography, Grid } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import BrowserPushCard from "../../components/Settings/BrowserPushCard";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background?.paper ?? theme.palette.fancyBackground,
  },
  mainPaper: {
    ...theme.scrollbarStyles,
    overflowY: "auto",
    flex: 1,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background?.paper ?? theme.palette.fancyBackground,
  },
}));

/**
 * Pagina dedicada ao Web Push — visivel no menu para todos os perfis (incl. user sem dashboard:view).
 */
export default function BrowserNotifications() {
  const classes = useStyles();

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>Notificações no navegador</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" color="textSecondary" paragraph>
              Ative aqui para receber alertas de novas mensagens e tickets mesmo com o sistema em segundo plano ou na PWA
              instalada.
            </Typography>
          </Grid>
          <Grid item xs={12} md={8} lg={6}>
            <BrowserPushCard gridItem={false} prominent />
          </Grid>
        </Grid>
      </Paper>
    </MainContainer>
  );
}
